//import '../css/main.css';
//import '../css/forms.css';

function globalize(iObj) {
    for (const i in iObj) {
        window[i] = iObj[i];
    }
}

// Global npm includes
import moment from 'moment';
window.moment = moment;
const jQuery = require('jquery');
window.$ = jQuery;
window.jQuery = jQuery;
import * as Popper from '@popperjs/core';
window.Popper = Popper;
import * as md5 from 'md5';
window.md5 = md5;
import Swal from 'sweetalert2'
window.Swal = Swal;
const QRCode = require('qrcode');
window.QRCode = QRCode;

// Global includes
import * as utils from '../ms_front_lib/utils';
globalize(utils);
import * as forms from '../ms_front_lib/forms/Forms';
globalize(forms);
import * as modals from '../ms_front_lib/components/MSModal';
globalize(modals);
import { Overlay } from './ui/Overlay';
window.Overlay = Overlay;

// Localization (FR hardcoded)
const lang = require('../lang/fr_FR/LC_MESSAGES/fr_FR.json');
window._l = (iText) => lang[iText] ?? iText;
window._h = (iText) => utils.htmlent(lang[iText] ?? iText);

if (gl_config.type == "site") {
    document.title = gl_config.site ? gl_config.site.name : "";
    // $('link[rel="icon"]').attr('href', `https://images.monnaie-services.com/site_icon/48x48/${gl_config.site.id}.png`);
    // $('link[rel="apple-touch-icon"]').attr('href', `https://images.monnaie-services.com/site_icon/180x180/${gl_config.site.id}.png`);
} else if (gl_config.type == "chain") {
    document.title = gl_config.chain ? gl_config.chain.label : "";
    // $('link[rel="icon"]').attr('href', gl_config.icon_url);
    // $('link[rel="apple-touch-icon"]').attr('href', gl_config.icon_url.replace("48x48", "180x180"));
}

// App
import { App } from './app';
import { Api } from './api';
import { Core } from './core';

$(function () {
    $('[data-toggle="tooltip"]').tooltip();

    if ($("title").length == 0) {
        $("head").append('<title/>');
    }
    if ($("meta[name='og:title']").length == 0) {
        $("head").append('<meta name="og:title" content=""/>');
    }
    if ($("meta[name='twitter:title']").length == 0) {
        $("head").append('<meta name="twitter:title" content=""/>');
    }

    window.gl_app = new App();
    window.gl_core = new Core();
    // console.log(gl_app.stage)

    let ws_url = 'https://ws.ticketingcine.com';
    if (window.gl_app.stage == 'beta') {
        ws_url = 'https://b-ws.ticketingcine.com';
    } else if (window.gl_app.stage == 'local') {
        //     if (process.env.WS_URL) {
        //         ws_url = process.env.WS_URL;
        //     } else {
        ws_url = 'https://b-ws.ticketingcine.com';
    }else if (gl_config.site_id.substring(3,5) == "99"){
        // Cas pour les site en PROD des cinéma de test "9995, 9996, 9997, etc..."
        ws_url = 'https://b-ws.ticketingcine.com';
    }
    // console.log("ws_url => " + ws_url);

    // Pour le SEO on doit supporter les urls avec des paramètres hors hash mais dans la query string.
    // Il faut les convertir en hash au démarrage sans reloader la page.
    if (window.location.hash == '' && window.location.search != '') {
        const params = new URLSearchParams(window.location.search);
        if (params.get("hash")) {
            let hash = params.get("hash");
            if (hash == 'showmovie' && params.get("id")) {
                hash += '?id=' + params.get("id");
            }
            console.log('initial location ' + window.location.href + ' replaced by #' + hash, window.location);
            window.history.replaceState('', 'Accueil', '/#' + hash);
            window.location.hash = '#' + hash;
        }
    }

    if (gl_mobile_app && (window.browser_id == null || window.browser_id.length != 32)) {
        window.browser_id = ('app-' + md5(window.location.href + '-' + Math.random() + '-' + Date.now())).substring(0, 32);
        localStorage.setItem('browser_id', window.browser_id);
    }

    window.gl_api = new Api(ws_url);
    // window.gl_api.n_log('Front App Started', {qwe:1, asd:2});
    window.gl_app.start();
    window.gl_core.loaded();  

    gl_core.on('core_push_received', (iData) => {
        if (gl_api) {
            gl_api.n_log('core_push_received', iData);
        }
        iData.message = 'core_push_received';
        window.last_push_message = iData;
        gl_app.setHash("#debug", false);
    });

    gl_core.on('core_push_initial', (iData) => {
        if (gl_api) {
            gl_api.n_log('core_push_initial', iData);
        }
        iData.message = 'core_push_initial';
        window.last_push_message = iData;
        gl_app.setHash("#debug", false);
    });

    gl_core.on('core_deep_link_received', (iData) => {
        if (gl_api) {
            gl_api.n_log('core_deep_link_received', iData);
        }
        iData.message = 'core_deep_link_received';
        window.last_push_message = iData;
        gl_app.setHash("#debug", false);
    });

    gl_core.on('core_push_opened', (iData) => {
        if (gl_api) {
            gl_api.n_log('core_push_opened', iData);
        }
        iData.message = 'core_push_opened';
        window.last_push_message = iData;
        gl_app.setHash("#debug", false);
    });


    // setTimeout(() => {
    //         window.last_push_message = { title: 'Test', body: 'Test body' };
    //         gl_app.setHash("#debug", false);
    //     }, 1000);
});

window.onerror = (errorMsg, url, line, col, error) => {
    console.error('OOPS onerror ', {
        errorMsg: errorMsg,
        url: url,
        lineNumber: line,
    });
    if (gl_api) {
        gl_api.w_log('OOPS onerror ', {
            href: window.location.href,
            user_agent: window.navigator.userAgent,
            errorMsg: errorMsg,
            url: url,
            line: line,
            col: col,
            mapped_stack :error.stack,
            unit_id : window.gl_app.stage == 'beta' ? 'b-ticketing-front' : 'ticketing-front',
        });
    }
    return false;
};

window.onunhandledrejection = (e) => {

    // Le site a été mis à jour, il faut recharger la page pour que le nouveau code soit pris en compte.
    if (e.reason?.name == "ChunkLoadError") {
        window.location.reload();
        return;
    }

    console.error('OOPS onunhandledrejection ', e.reason);
    if (gl_api) {
        gl_api.w_log('OOPS onunhandledrejection', {
            href: window.location.href,
            user_agent: window.navigator.userAgent,
            reason: JSON.parse(JSON.stringify(e.reason, Object.getOwnPropertyNames(e.reason))),
            mapped_stack : e.reason?.stack,
            unit_id : window.gl_app.stage == 'beta' ? 'b-ticketing-front' : 'ticketing-front',
        });
    }
};

window.addEventListener("message", (event) => {
    console.log('Received message "' + event.data + '"', event);
    if (gl_mobile_app) {
        let payload = event.data;
        if (typeof (payload) == 'object' && payload.type) {
            if (gl_api) {
                gl_api.n_log('Received core message ' + payload.type, payload.data);
            }
            gl_core.trigger(payload.type, payload.data);
            return;
        }
    }

    if (event.data == "reload") {
        window.location.reload();
    }
}, false);



// $(window).on("mouseover", (e) => {
//     if ($(e.target).hasClass('clipboard_over')) {
//         window.$clipboard_copy_btn = $('<svg viewBox="0 0 24 24" class="clipboard_copy_btn"><path d="M19,21H8V7H19M19,5H8A2,2 0 0,0 6,7V21A2,2 0 0,0 8,23H19A2,2 0 0,0 21,21V7A2,2 0 0,0 19,5M16,1H4A2,2 0 0,0 2,3V17H4V3H16V1Z"></path></svg>');
//         window.$clipboard_copy_btn.appendTo($(e.target));
//         //console.log('mouseover');
//     }
// });

// $(window).on("mouseout", (e) => {
//     if ($(e.target).hasClass('clipboard_over')) {
//         window.$clipboard_copy_btn.remove();
//         window.$clipboard_copy_btn = false;
//         //console.log('mouseout');
//     }
// });

$(window).on("click", (e) => {
    if ($(e.target).hasClass('clipboard_over')) {
        navigator.clipboard.writeText($(e.target).text());
    }
});

// disable serviceWorker
if (navigator.serviceWorker) {
    navigator.serviceWorker.getRegistrations().then(registrations => {
        for (const registration of registrations) {
            registration.unregister();
        }
    });
}

window.onbeforeprint = (event) => {
    // console.log("Before print", event);
};

window.onafterprint = (event) => {
    // console.log("After print", event);
};

